import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { login } from "../redux/features/authSlice";
import { getCookie } from "../config/varConfig";
import { hasAccessToRoute } from "../utils/hasAccessToRoute";
import AccessDenied from "../components/AccessDenied";

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { isAuthenticated, user } = useSelector((state) => state.auth);

  const cookieUser = getCookie("user") ? JSON.parse(getCookie("user")) : null;
  const token = getCookie("token");

  useEffect(() => {
    if (!isAuthenticated && cookieUser && token) {
      dispatch(login(cookieUser));
    }
  }, [isAuthenticated, token, dispatch]);

  // not logged in at all
  if (!isAuthenticated && (!cookieUser || !token)) {
    return <Navigate to="/login" />;
  }

  const currentUser = user || cookieUser;

  // check route access for subadmin
  if (!hasAccessToRoute(currentUser, location.pathname)) {
    return (
      // <div className="flex items-center justify-center h-full">
      //   <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md text-center">
      //     <span className="text-red-500 text-2xl">⚠️</span>
      //     <p className="text-red-600 mt-2 font-medium">
      //       Access denied. No permission for this page.
      //     </p>
      //   </div>
      // </div>

      <AccessDenied/>
    );
  }

  return children;
};

export default PrivateRoute;